import { render, staticRenderFns } from "./SelectFormAndPerson.vue?vue&type=template&id=2df48a6d&scoped=true&"
import script from "./SelectFormAndPerson.vue?vue&type=script&lang=js&"
export * from "./SelectFormAndPerson.vue?vue&type=script&lang=js&"
import style0 from "./SelectFormAndPerson.vue?vue&type=style&index=0&id=2df48a6d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df48a6d",
  null
  
)

export default component.exports